var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:{ 'has-link': _vm.hasLink },on:{"click":function($event){$event.preventDefault();return _vm.toLink.apply(null, arguments)}}},_vm._l((_vm.columns),function(column,index){return _c('td',{key:index,class:_vm.cssClass(column)},[_c(column.component,{tag:"component",attrs:{"value":_vm.getValue(index)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }